import { Outlet } from 'react-router-dom';
import { TopNav } from '@/components/TopNav';
import { TabBar } from '@/components/TabBar';

export function Layout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-soi-600 focus:px-4 focus:py-2 focus:text-white"
      >
        Skip to content
      </a>
      <TopNav />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <TabBar />
    </div>
  );
}
